import * as React from "react";

import ErrorIcon from "@mui/icons-material/Error";
import InfoIcon from "@mui/icons-material/Info";
import WarningIcon from "@mui/icons-material/Warning";
import { Box, Stack } from "@mui/material";

import { Heading } from "foundations/Heading/Heading";
import { Text } from "foundations/Text/Text";
import { ReactElement } from "react";

interface GenericErrorProps {
  type: "info" | "warning" | "error";
  title: string;
  message?: string | ReactElement;
  boldErrorTitle?: boolean;
}

export function GenericErrorMessage(props: GenericErrorProps): React.ReactNode {
  let icon: React.ReactNode;
  switch (props.type) {
    case "info":
      icon = (
        <InfoIcon
          sx={{ width: 80, height: 80, color: "secondary.main" }}
          role="presentation"
        />
      );
      break;
    case "warning":
      icon = (
        <WarningIcon
          sx={{ width: 80, height: 80, color: "warning.main" }}
          role="presentation"
        />
      );
      break;
    case "error":
    default:
      icon = (
        <ErrorIcon
          sx={{ width: 80, height: 80, color: "error.main" }}
          role="presentation"
        />
      );
      break;
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: 250,
        height: "100%",
      }}
    >
      <Stack
        sx={{
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {icon}
        <Heading
          variant="h4"
          fontWeight={props.boldErrorTitle ? "bold" : "normal"}
          mt={1}
          mb={2}
        >
          {props.title}
        </Heading>
        {props.message && <Text>{props.message}</Text>}
      </Stack>
    </Box>
  );
}
